import React from 'react';
import { Accordion } from 'react-bootstrap';

const Blogs = () => {
    return (
        <div className='container my-3'>
            <h3> I have answered The three question</h3>
            <div>
            <Accordion>
  <Accordion.Item eventKey="0">
    <Accordion.Header> Q-1: Difference between authorization and authentication?</Accordion.Header>
    <Accordion.Body>
   <ul>
       <li className='text-danger fw-bold'>Authorization:-<ol>
           <li>authentication is the process of verifying who someone is</li>
           <li>Authorization method access control for urls</li>
           <li>which ultimately gives us full permission to access the resources such as information, files, databases, funds, locations, almost anything.</li>
           <li>Authentication factors required for authorization may vary, depending on the security level.</li>
           <li>It is the process of verifying whether access is allowed or not.</li>
         </ol></li>

       <li className='text-primary fw-bold '>Authentication:-<ol>
           <li>authorization is the process of verifying what specific applications, files, and data a user has access to</li>
           <li>authentication method need Login Form </li>
           <li>Authentication is usually done by a username and password, and sometimes in conjunction with factors of authentication</li>
           <li> Single-Factor, Two-Factor, Multi-Factor authentication are using based on the security level</li>
           <li>It merely identifies who you are, nothing else.</li>
         </ol></li>
   </ul>
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="1">
    <Accordion.Header>Q-2: Why are you using firebase? What other options do you have to implement authentication?</Accordion.Header>
    <Accordion.Body>
   <div><h4> Firebase Authentication provides backend services, easy-to-use SDKs, and ready-made UI libraries to authenticate users to your app
    </h4>
        <h3>Firebase Alternatives:-</h3>
        <ul>
            <li>Parse :- Open Source Backend Platform</li>
            <li>Back4app :- Parse Hosting Platform</li>
            <li>Kinvey :- Mobile Backend as a Service (mBaaS) for the Enterprise</li>
            <li>Backendless :- Mobile Backend and API Services Platform</li>
            <li>Kuzzle :- Backend for web, hybrid, or native mobile apps and IoT projects</li>
        </ul>
    </div>
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item eventKey="2">
    <Accordion.Header>Q-3: What other services does firebase provide other than authentication?</Accordion.Header>
    <Accordion.Body>
     <div>
         <h4>There are many services which Firebase provides, Most useful of them are:</h4>
         <ul>
             <li>Cloud Firestore</li>
             <li>Cloud Functions</li>
             <li>Hosting</li>
             <li>Cloud Storage</li>
             <li>Google Analytics</li>
             <li>Predictions</li>
             <li>Cloud Messaging</li>
         </ul>
     </div>
    </Accordion.Body>
  </Accordion.Item>

</Accordion>
            </div>
        </div>
    );
};

export default Blogs;